
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ui-ux-services",
      function () {
        return require("private-next-pages/ui-ux-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ui-ux-services"])
      });
    }
  